import { render, staticRenderFns } from "./contact-view-modal.vue?vue&type=template&id=cbc9450c&scoped=true&"
import script from "./contact-view-modal.vue?vue&type=script&lang=js&"
export * from "./contact-view-modal.vue?vue&type=script&lang=js&"
import style0 from "./contact-view-modal.vue?vue&type=style&index=0&id=cbc9450c&lang=scss&scoped=true&"
import style1 from "./contact-view-modal.vue?vue&type=style&index=1&id=cbc9450c&lang=scss&scoped=true&"
import style2 from "./contact-view-modal.vue?vue&type=style&index=2&id=cbc9450c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc9450c",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QImg,QTab,QTabPanel,QTabPanels} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QImg,QTab,QTabPanel,QTabPanels})
